import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: []
    ,moduleRights:[]
    ,appName:  JSON.stringify(require('../package.json').name.replace(/"/g, '').replace(/'/g, '')) || 'appName'
    ,appVersion:  JSON.stringify(require('../package.json').version.replace(/"/g, '').replace(/'/g, '')) || '0'
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload.user
    }
    ,getUser: state => {
      return state.user
    }
    // ,setModuleRights (state, payload) {
    //   state.moduleRights = payload.user
    // }
    // ,getModuleRights: state => {
    //   return state.moduleRights
    // }
  },
  actions: {},
});
